import React, { Component } from 'react';
import { t } from 'ttag';
import { connect } from 'react-redux';
import style from './packageBox.scss';
import Modal from '../../modal/modalComponent';
import DependencyList from '../../dependencies/dependencyListComponent';
import Price from '../../util/Price';

class PackageBoxView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalVisibility: false,
        };
    }

    onChange = (serialParentUid) => {
        const pack = this.props.package;
        if (pack.mandatory || serialParentUid) {
            return null;
        }
        return this.props.onSelectItem(pack);
    };

    showModal = () => {
        if (!this.props.package.disabled) {
            return null;
        }

        return this.setState({
            modalVisibility: true,
        });
    };

    hideModal = (event) => {
        event.preventDefault();
        return this.setState({
           modalVisibility: false,
        });
    };

    renderName = (part) => {
        if (part.code !== '') {
            return `${part.name} [${part.code}]`;
        }
        return `${part.name}`;
    };

    render = () => {
      let isSelected = false;
      let isMarked = false;
      let containerStyle = style.container;
      let serialParentUid = 0;

      /**
       * Constant has to be named anything else than package,
       * because "package" is not allowed as identifier
       */
      const pack = this.props.package;
      const { selectedItems, configuration } = this.props;

      for (let i = 0; i < selectedItems.length; i += 1) {
        if (selectedItems[i].uid === pack.uid) {
          isSelected = true;
          serialParentUid = selectedItems[i].serial_parent_uid;
        }
      }

      for (let i = 0; i < configuration.markedDependencies.length; i += 1) {
        if (configuration.markedDependencies[i] === pack.uid) {
            isMarked = true;
        }
      }

      if (pack.disabled === true) {
        isSelected = false;
        containerStyle = style.container__disabled;
      }

      if (isSelected) {
        containerStyle = style.container__active;
      }

      if (isMarked) {
        containerStyle += ` ${style.container__marked}`;
    }

    return (
      <label htmlFor={pack.uid}>
        <input className={style.checkbox} type="checkbox" value={pack.uid} id={pack.uid} checked={isSelected} onChange={() => this.onChange(serialParentUid)} />
        {
          pack.disabled ?
          <Modal title="" showNotice="true" content={<DependencyList item={pack} parts={this.props.parts} configuration={configuration.configurations} closeModal={this.hideModal} />} visibility={this.state.modalVisibility} closeModal={this.hideModal} />
          : null
        }
        <div className={containerStyle} onClick={this.showModal}>
          <div>
          {
              pack.image ?
                <img
                  className={style.image}
                  src={`/${pack.image}`}
                  alt={pack.name}
                />
                : null
          }
          </div>
          <div className={style.detailsContainer}>
            <div className={style.details}>
              <h2>{this.renderName(pack)}</h2>
              <h4>
                {pack.weight}KG +<Price value={this.props.resolvePrice(pack, serialParentUid)} />
              </h4>
            </div>
          </div>
        </div>
        <button type="button" className={style.button} onClick={this.props.showPackageDetails}>{t`Details einblenden`}</button>
      </label>
    );
  }
}

const mapStateToProps = state => ({
  configuration: state.configuration,
});

const PackageBox = connect(
  mapStateToProps
)(PackageBoxView);


export default PackageBox;
